var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupMenuUnread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 2.33301H7.00008C4.48592 2.33301 3.22885 2.33301 2.44779 3.11405C1.66675 3.89511 1.66675 5.15218 1.66675 7.66634V8.99967C1.66675 11.5138 1.66675 12.7709 2.44779 13.5519C3.22885 14.333 4.48592 14.333 7.00008 14.333H8.33341C10.8475 14.333 12.1047 14.333 12.8857 13.5519C13.6667 12.7709 13.6667 11.5138 13.6667 8.99967V8.33301",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 4.00033C14.3334 5.28899 13.2887 6.33366 12.0001 6.33366C10.7114 6.33366 9.66675 5.28899 9.66675 4.00033C9.66675 2.71166 10.7114 1.66699 12.0001 1.66699C13.2887 1.66699 14.3334 2.71166 14.3334 4.00033Z",
    fill: "#0095FF",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33301H7.66667",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11H10.3333",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuUnread);
export default __webpack_public_path__ + "static/media/group_menu_unread.901c862555ecb4faca002416f24721ca.svg";
export { ForwardRef as ReactComponent };